/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import type { EfbButton } from '../../atoms/button/button';

/**
 * Description of the component.
 */
@Component({
  tag: 'efb-hub-youth-card',
  styleUrl: 'hub-youth-card.scss',
  shadow: true,
})
export class EfbHubYouthCard {
  @Prop() titleText: string;

  @Prop() text?: string;

  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedbutton(): EfbButton {
    return parseIfString(this.button);
  }

  render() {
    return (
      <Host>
        <div class="hub-youth-card">
          <div class="text-wrapper">
            <efb-title text={this.titleText} size="xxs" bold />
            {this.text && <efb-paragraph text={this.text} />}
          </div>

          <efb-button class="button" {...this.parsedbutton} variant="purple" />
        </div>
      </Host>
    );
  }
}
